export const isExternalLink = (link: string) => {
  return /^(http:\/\/|https:\/\/)/.test(link || '');
};


// WEBPACK FOOTER //
// ./src/helpers/isExternalLink.ts